import { useNavigate, useParams, useLocation } from "react-router-dom";

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const router = {
      navigate: useNavigate(),
      params: useParams(),
      location: useLocation(),
    };
    return <Component {...props} router={router} />;
  }

  return ComponentWithRouterProp;
}
